import { render, staticRenderFns } from "./DoughnutChartSatisfaction.vue?vue&type=template&id=3ca8ee3a&scoped=true&"
import script from "./DoughnutChartSatisfaction.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartSatisfaction.vue?vue&type=style&index=0&id=3ca8ee3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8ee3a",
  null
  
)

export default component.exports